<template>
  <div class="p-menu-subsidy-coupon-detail">
    <div class="name-coupon">
      {{ subsidy.availableData.dispSubsidyNm }}
    </div>

    <div class="p-menu-subsidy-coupon-detail__list">
      <dl>
        <dt><span>申込期間</span></dt>
        <dd>
          {{getApplicationDate }}
        </dd>
      </dl>

      <dl
        v-if="
          subsidy.availableData.parsonalUsedMaxCnt &&
          subsidy.remainingCount &&
          subsidy.remainingCount >= 0
        "
      >
        <dt><span>保有枚数</span></dt>
        <dd>
          {{ subsidy.remainingCount | formatInteger }}/{{
            subsidy.availableData.parsonalUsedMaxCnt | formatInteger
          }}枚
        </dd>
      </dl>

      <dl
        v-if="
          subsidy.availableData.parsonalUsedMaxTotalAmt &&
          subsidy.remainingAmount &&
          subsidy.remainingAmount >= 0
        "
        class="available_balance"
      >
        <dt><span>利用可能残金額</span></dt>
        <dd>
          {{ subsidy.remainingAmount | formatInteger }}/{{
            subsidy.availableData.parsonalUsedMaxTotalAmt | formatInteger
          }}円
        </dd>
      </dl>

      <dl class="unit-price" v-for="(price, index) in subsidy.availableData.priceList" :key="index">
        <dt><span v-if="index === 0">補助単価</span></dt>
        <dd>
          {{ price.price | formatInteger }}円
        </dd>
        <dt v-if="index === 0 && subsidy.availableData.priceList.length > 1"><span >利用期限</span></dt>
        <dd v-if="subsidy.availableData.priceList.length > 1">
          <span v-if="price.limApplicableDateFrom">
            {{ price.limApplicableDateFrom }}
          </span>
          <span v-if="price.limApplicableDateTo"> ~{{ price.limApplicableDateTo }} </span>
        </dd>
      </dl>
    </div>
    
    <div class="planDetail">
      {{ getMessageCoupon }}
    </div>

    <!--
      補助金詳細の表示仕様変更の為一度コメントアウト
      UI/UX対応と要確認
    -->
    <!-- <div class="mt-4 md:text-sm">
      本人同行要否：
      {{
        subsidy.availableData.personAccompanyFlg ===
        CONST_DATA.PERSON_ACCOMPANY_FLG.NEED
          ? "必要"
          : "不要"
      }}
    </div>
    <div class="mt-4 md:text-sm">
      {{
        subsidy.availableData.usedLimTerm === "01"
          ? "上記適用期間内での制限適用となります"
          : "月の利用制限となります"
      }}
    </div> -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "MenuSubsidyCouponDetail",
  props: {
    subsidy: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getMessageCoupon() {
      const subsidy = this.subsidy;
      let message = [];

      // 利用制限期間
      if (subsidy.availableData.usedLimTerm === "01") {
        message.push("上記適用期間内での制限適用となります");
      } else {
        message.push("月の利用制限となります");
      }

      // 利用上限総額（数）
      // usetemplateimUnit(利用制限単位)による条件分岐は不要。
      // usetemplateimUnitが01(個人)の場合は、usedMaxCnt・usedMaxTotalAmtはセットされない
      if (
        subsidy.availableData.usedMaxCnt > 0 &&
        subsidy.availableData.usedMaxTotalAmt > 0
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.usedMaxCnt)}枚まで/※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。`);
      } else if (
        subsidy.availableData.usedMaxCnt > 0 &&
        !subsidy.availableData.usedMaxTotalAmt
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.usedMaxCnt)}枚まで`);
      } else if (
        !subsidy.availableData.usedMaxCnt &&
        subsidy.availableData.usedMaxTotalAmt > 0
      ) {
        message.push("※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。");
      }

      // 会員最低負担額
      if (subsidy.availableData.minChargeAmt === 1) {
        message.push("必ず自己負担が必要になります。");
      } else if (subsidy.availableData.minChargeAmt > 1) {
        message.push(`${this.$filters.formatInteger(subsidy.availableData.minChargeAmt)}円以上のご負担が必要となります。`);
      }

      if (subsidy.availableData.costUnderChargeableFlg === 0 && subsidy.availableData.minChargeAmt == 0) {
        message.push("利用金額が補助金額に満たない場合は利用不可");
      }

      // ライフでは最低年齢の表示は不要
      // if (subsidy.availableData.minTgtAge) {
      //   message.push(`${this.$filters.formatInteger(subsidy.availableData.minTgtAge)}歳以上が対象`);
      // }

      // ライフは家族会員のみの利用は無いので、判定の必要なし => 表示文言の記載はない（仕様書にも記載なし）
      // if (subsidy.availableData.personAccompanyFlg === this.CONST_DATA.PERSON_ACCOMPANY_FLG.NEED) {
      //   message.push("家族会員のみでの利用不可");
      // }

      if (subsidy.availableData.multipleUnusableFlg === this.CONST_DATA.PERSON_ACCOMPANY_FLG.NOT_NEED) {
        message.push("併用可");
      } else {
        message.push("併用不可");
      }

      if (subsidy.availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED) {
        message.push("対象メニューの申込で自動で利用できます");
      } else {
        message.push("利用申請があった場合のみ利用できます");
      }
      return message.join('/');
    },
    getShowPriceData() {
      const priceList = this.subsidy.availableData.priceList;
      const today = moment().startOf('days'); // 日付比較のため.startOf('days')で時間設定を00:00:00にする
      if (priceList && priceList.length > 0) {
        // 申込日が限定適用期間に含まれる補助金単価情報を使用する
        const len = priceList.length;
        for (let i = 0; i < len; i++) {
          const price = priceList[i];
          if (moment(price.limApplicableDateFrom).isSameOrBefore(today, 'day') &&
            moment(price.limApplicableDateTo).isSameOrAfter(today, 'day')) {
            // 表示する文言を返す
            return price;
          }
        }
      }
      return null;
    },
    getLimApplicableDateText() {
      const price = this.getShowPriceData;
      if (price) {
        return `${this.formatDate(price.limApplicableDateFrom)}～${this.formatDate(price.limApplicableDateTo)}`;
      }
      return '';
    },
    getPriceText() {
      const price = this.getShowPriceData;
      if (price) {
        return price.price;
      }
      return '';
    },
    /**
     * 申込期間の取得
     * ※ライフでは申込期間ではなく限定適用期間を表示する
     */
    getApplicationDate() {
      const priceList = this.subsidy.availableData.priceList;
      let start = null,
        end = null;
      if (priceList && priceList.length > 0) {
        start = moment(priceList[0].limApplicableDateFrom);
        end = moment(priceList[0].limApplicableDateTo);

        const len = priceList.length;
        for (let i = 1; i < len; i++) {
          const price = priceList[i];
            
          if(price.limApplicableDateFrom) {
            const priceStart = moment(price.limApplicableDateFrom);
            if (priceStart.isBefore(start)) {
              start = priceStart;
            }
          }

          if (price.limApplicableDateTo) {
            const priceEnd = moment(price.limApplicableDateTo);
            if(priceEnd.isAfter(end)) {
              end = priceEnd;
            }
          }
        }
      }

      return `${start.format("YYYY/MM/DD")}～${end.format("YYYY/MM/DD")}`;
    }
  },
  methods: {
    /**
     * 日付フォーマット
     */
    formatDate(date) {
      return moment(date, "YYYYMMDD hh:mm:ss").format("YYYY/MM/DD");
    }
  }
};
</script>

<style lang="scss" scoped>
.p-menu-subsidy-coupon-detail {
  .name-coupon {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  .planDetail {
    color: #1f2021;
    display: inline-block;
    margin-bottom: 10px;
  }

  dl {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;
    row-gap: 0.25rem;
    width: 100%;

    dt {
      margin-right: 33px;
      span {
        --tw-bg-opacity: 1;
        background-color: rgba(229,231,235,var(--tw-bg-opacity));
        min-width: 64px;
        padding: .125rem .5rem;
      }
    }

    dd {
      width: 80%;
    }

    @include mq() {
      dt {
        margin-right: 6px;
      }

      dd {
        width: 75%;
      }
    }
  }

  .unit-price {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    row-gap: 0;
    width: 100%;
    dd {
      width: calc(49% - 105px);
    }

    @include mq() {
      dt,
      dd {
        display: flex;
      }
      dt {
        margin-right: 6px;
      }
      :nth-child(1) { order: 1; }
      :nth-child(2) { order: 3; }
      :nth-child(3) { order: 2; }
      :nth-child(4) { order: 4; }
    }
  }

  .available_balance {
    display: flex;
    dt,
    dd {
      width: auto;
    }
  }
}
</style>